import React from 'react';
import { CtaButton } from './ui/CtaButton';
const features = ['🌳 Árbol de Habilidades (póster doble)', '🛡️ Sistema de 5 Rangos y Escudos recortables', '🎁 20 Tarjetas de Poderes Especiales', '🎡 El Elegidor Veloz (rueda armable)', '📅 Tablero de Conquistas Mensual', '🗓️ Calendario de Días Temáticos anual', '🏆 La Semana Master de los 6 tomos', '🎓 Certificados de Graduación XL', '🚫📱 Plan del Día Cero Pantallas'];
export function TableroDetails() {
  return <section className="py-16 px-4 bg-zinc-950 border-t border-zinc-900" data-id="element-202" data-mp="2crwgodnh8lad">
      <div className="max-w-5xl mx-auto" data-id="element-203" data-mp="2ctzf9m2p3mqp">
        <div className="text-center mb-10" data-id="element-204" data-mp="1y41mesttm8v6">
          <h2 className="text-3xl md:text-4xl font-bold mb-3 text-white" data-id="element-205" data-mp="1y15nb168le55">
            🕊️ ¿Qué agrega el Tablero de Control Familiar?
          </h2>
          <p className="text-lg text-zinc-400" data-id="element-206" data-mp="1p2bsngcguxu8">
            Convierte el pack en un hábito de por vida.
          </p>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-207" data-mp="1t3npa5trcjbx">
          <table className="w-full min-w-[600px] border-collapse" data-id="element-208" data-mp="98d6n873gtbw">
            <thead data-id="element-209" data-mp="9apvm5b9s3yg">
              <tr className="border-b border-zinc-800" data-id="element-210" data-mp="49k2w7hm0gox">
                <th className="text-left py-4 px-6 text-zinc-400 font-medium" data-id="element-211" data-mp="490j0l8efi89">
                  SITUACIÓN EN CASA
                </th>
                <th className="text-left py-4 px-6 text-red-400 font-medium bg-red-500/5" data-id="element-212" data-mp="e7q38knrpero">
                  ❌ Sin el Tablero
                </th>
                <th className="text-left py-4 px-6 text-yellow-400 font-medium bg-yellow-400/5" data-id="element-213" data-mp="3mob57hhzf7la">
                  ✅ Con Tablero
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800/50" data-id="element-214" data-mp="86ze41zopl6">
              {[['Tu hijo pide hacer el pack', 'Lo convencés con esfuerzo', 'Lo pide solo por estrellas'], ['No sabés qué actividad dar hoy', 'Decidís con energía mental', 'La rueda decide sola'], ['Querés que el hábito dure', 'Dura mientras hay novedad', 'Sistema de 365 días'], ['El niño necesita incentivos', "Le decís 'muy bien' y ya", 'Gana poderes especiales']].map((row, i) => <tr key={i} className="hover:bg-zinc-900/30 transition-colors" data-id="element-215" data-mp="35ot5qxd04tih" data-mpi={i}>
                  <td className="py-4 px-6 text-zinc-300" data-id="element-216" data-mp="39pv7bkue5hnm">{row[0]}</td>
                  <td className="py-4 px-6 text-zinc-500 bg-red-500/5" data-id="element-217" data-mp="3eo6etox7rg2o">
                    {row[1]}
                  </td>
                  <td className="py-4 px-6 text-white font-medium bg-yellow-400/5" data-id="element-218" data-mp="3jo17ny0jufqd">
                    {row[2]}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-10" data-id="element-219" data-mp="yv7gu1g52twg">
          <h3 className="text-xl font-bold text-white mb-6 text-center" data-id="element-220" data-mp="2jdi0dv5jqlyo">
            ✅ El Tablero incluye (+18 herramientas):
          </h3>
          <div className="grid md:grid-cols-3 gap-3 mb-8" data-id="element-221" data-mp="2ei2pnc2u566h">
            {features.map((feature, i) => <div key={i} className="flex items-center gap-2 text-zinc-300 text-sm" data-id="element-222" data-mp="29mnguyjoq0gx" data-mpi={i}>
                <span className="text-base" data-id="element-223" data-mp="20olg8k3v59u6">{feature.split(' ')[0]}</span>
                <span data-id="element-224" data-mp="1vp8n5hmef6j5">{feature.substring(feature.indexOf(' ') + 1)}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-225" data-mp="1qpcfn8ehswyu">
            <CtaButton label="QUIERO EL PACK + TABLERO" target="oferta-premium" data-id="element-226" data-mp="1qqe1m7x1r3vc" />
          </div>
        </div>
      </div>
    </section>;
}